import React, { useEffect, useState } from "react";
import ConfirmationDlg from "../ConfirmationDlg";
import { DynamicProblemTypeForm } from "./form";
import NormalInput from "../form/HorizontalNormalInput";


export const ProblemTypeFilter = ({
  onChange,
  type = "button",
  defaultValue = null,
  defaultOptionsValue = [],
  onNoteChange,
  defaultNote = null,
}) => {
  const [selectedProblemType, setSelectedProblemType] = useState(null);
  const [selectedProblemTypePrev, setSelectedProblemTypePrev] = useState([]);
  const [selectedTempProblemType, setSelectedTempProblemType] = useState(null);
  const [selectedTempProblemTypePrev, setSelectedTempProblemTypePrev] =
    useState([]);
  const [tempNote, setTempNote] = useState("");
  const [open, setOpen] = useState();
  const handleClose = () => {
    setOpen(false);
  };

  const handleSelect = () => {
    if (!selectedTempProblemType) {
      onChange(null);
      setSelectedProblemType(null);
      setSelectedProblemTypePrev([]);
    } else {
      onChange(selectedTempProblemType);
      setSelectedProblemType(selectedTempProblemType);
      setSelectedProblemTypePrev(selectedTempProblemTypePrev);
    }
    onNoteChange(tempNote);
    setOpen(false);
  };

  const handleChangeProblemType = (problemType, selectedProblemTypePrev) => {
    setSelectedTempProblemType(problemType);
    setSelectedTempProblemTypePrev(selectedProblemTypePrev);
  };

  const handleNoteChange = (note) => {
    setTempNote(note);
  };

  return (
    <>
      {type === "button" && (
        <button
          onClick={() => {
            setOpen(true);
          }}
          className="btn btn-outline-theme w-100"
        >
          {!selectedProblemType && "- Filter Problem Type - (All)"}
          {(selectedProblemType && selectedProblemType.problem_type_name) ||
            "-"}
        </button>
      )}
      {type === "input" && (
        <NormalInput
          onClick={() => {
            setOpen(true);
          }}
          type="text"
          value={
            selectedProblemType
              ? selectedProblemType.problem_type_name
              : defaultValue
              ? defaultValue.problem_type_name
              : ""
          }
          onchange={(e) => {}}
          label="Service Group / Problem Type"
          placeholder="Select Service Group / Problem Type"
          style={{
            cursor: "pointer",
            caretColor: "transparent",
          }}
        />
      )}

      <ConfirmationDlg
        title={"Select Problem Type"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSelect}
        btnSubmitText={"Confirm"}
        btnCancelText={"Cancel"}
      >
        <DynamicProblemTypeForm
          onChange={handleChangeProblemType}
          onNoteChange={handleNoteChange}
          selectedProblemTypePrev={
            selectedProblemTypePrev.length > 0
              ? selectedProblemTypePrev
              : defaultOptionsValue
          }
          defaultNote={defaultNote}
        />
      </ConfirmationDlg>
    </>
  );
};
